module.exports = __webpack_public_path__ + "img/4.4a6f529c.png";